import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const nexuseldConfig: TSPConfig = {
  key: 'nexuseld',
  name: 'Nexus ELD',
  imageName: 'NexusELD',
  category: TSPCategory.API_KEY,
  helpText:
    'Please request a Company API Key from Nexus ELD support. Then input it here.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter Company API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default nexuseldConfig;
